/**
 * Where the queue sends a customer once it has nothing left to ask. A verification has no payment
 * page, so it ends on the review screen. No i18n or store imports, so it stays testable.
 */

/** Terminal screen for a verification with no order behind it. */
export const KYC_UNDER_REVIEW_ROUTE_PATH = '/identity/kyc-under-review';

export const PAYMENT_ROUTE_PATH = '/payment';

/**
 * @param {boolean} isHostedKyc
 * @returns {string}
 */
export const resolveQueueExitRoute = (isHostedKyc) => (
  isHostedKyc ? KYC_UNDER_REVIEW_ROUTE_PATH : PAYMENT_ROUTE_PATH
);

/**
 * Core clears the queue from the provider's webhook, so it can still list the step just finished
 * and routing back into it would loop. Only holds for the Sumsub component's lifetime.
 *
 * @param {{isHostedKyc: boolean, hasSubmittedToSumsub: boolean, nextUrl: string|undefined}} params
 * @returns {boolean}
 */
export const shouldExitToKycReview = ({ isHostedKyc, hasSubmittedToSumsub, nextUrl }) => (
  Boolean(isHostedKyc && hasSubmittedToSumsub && nextUrl?.includes('sumsub'))
);
